<main>
  <div class="content">
    <div class="grid-12">
      <div class="span-12-4">
        <div class="brand__wrapper">
          <div class="app-icon"></div>
          Sierra Finance
        </div>
        <h1>Access Denied</h1>
        <p class="message">You do not have the required permissions to access this page.</p>
        <div class="row-sm mt-[2rem]">
          <p-button label="Logout" (onClick)="logout()" />
        </div>
      </div>
    </div>
  </div>
</main>
